import type { ReactNode } from 'react';
import { ToastProvider, ToastViewport } from '@/shared/ui/toast/toast';

export function Providers({ children }: { children: ReactNode }) {
  return (
    <ToastProvider>
      {children}
      <ToastViewport />
    </ToastProvider>
  );
}
